export default __webpack_public_path__ + "static/media/evr.fd75e4fa.png";